import { useEffect, useState } from 'react';
import ConsoleTemplate from '../_shoru_shared_library/template/ConsoleTemplate';
import clashBotConsoleRouter from './clashBotConsoleRouter';
import ClashBotAppBar from '../components/ClashBotAppBar';
import { AuditioneeViewer } from './overlays/AuditioneeViewer';
import { UpdateHistory } from './functions/UpdateHistory';

function ClashBotConsole() {

  const consoleName = 'clashbot';
  const [season, setSeason] = useState(null);
  const [auditionees, setAuditionees] = useState(null);
  const [clashBotData, setClashBotData] = useState(null);
  const [register, setRegister] = useState(null);

  const [selected, setSelected] = useState(null);
  const [history, setHistory] = useState([]);
  
  return (

    <>
      {
        (selected && register && auditionees && clashBotData) && 
        <AuditioneeViewer index={selected} auditionees={auditionees} register={register} data={clashBotData} setSelected={setSelected} />
      }
      <ConsoleTemplate 
        admin
        getOrganisationData
        appBar={<ClashBotAppBar />}
        router={clashBotConsoleRouter(season, auditionees, clashBotData, register)} 
        accentColour='#d63031'
        appName='castingbot'
        consoleName={consoleName}

        // Additional props - added just for this console
        additionalProps={{
          season: season,
          setSeason: setSeason,
          auditionees: auditionees,
          setAuditionees: setAuditionees,
          clashBotData: clashBotData,
          setClashBotData: setClashBotData,
          register: register,
          setRegister: setRegister,
          setSelected: setSelected,
          history: history,
          setHistory: setHistory
        }}
      />
    </>

  )

}

export default ClashBotConsole;